<template>
  <div class="home">
    <div class="col-left">
      <home-message />
    </div>
    <div class="col-right">
      <main-menu />
      <slot>Default content</slot>

      <div class="logos">
        <img
          src="../assets/image-11.png"
          srcset="../assets/image-11@2x.png 2x, ../assets/image-11@3x.png 3x"
        >
        <img
          src="../assets/slides-mepyd-11.png"
          srcset="../assets/slides-mepyd-11@2x.png 2x, ../assets/slides-mepyd-11@3x.png 3x"
        >

        <img
          src="../assets/image-12.png"
          srcset="../assets/image-12@2x.png 2x, ../assets/image-12@3x.png 3x"
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name: 'HomeLayout',
};
</script>
<style lang="scss" scoped>
@import "../scss/style";
.home {
  min-height: 100vh;
  min-width: 100%;
  overflow: hidden;
  @media screen and (min-width: 660px) {
    display: flex;
  }
}
.col-left {
  // padding-top: 50px;
  background-color: $blue-dark;
  color: white;
  position: relative;
  overflow: hidden;
  min-width: 100%;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 380px;
  @media screen and (min-width: 660px) {
    padding-right: 20px;
    padding-left: 20px;
    max-width: 380px;
    min-width: 320px;
  }
  @media screen and (min-width: 1441px) {
    padding-right: 22px;
    padding-left: 76px;
    max-width: 620px;
  }
}
.col-right {
  background-color: #f6f7f9;
  color: $blue-dark;
  flex: 1;
  padding-top: 50px;
  padding-right: 20px;
  padding-left: 20px;
  position: relative;

  @media screen and (min-width: 1441px) {
    padding-left: 87px;
    padding-right: 136px;
  }
}


.card {
  border-radius: 16px;
  border: solid 2px #d6d6d6;
  background-color: #ffffff;
  padding: 40px 30px;
  // padding: 50px 68px;
  transition: all 0.2s ease-in;
  cursor: pointer;
  &:hover {
    border-color: #2e89df;
    background-color: #eff7ff;
    text-decoration: none;

    .card-arrow {
      opacity: 1;
    }
  }
}
.card + .card {
  margin-top: 24px;
}
.card-container {
  display: flex;
  align-items: center;
  flex-direction: column;

  @media screen and (min-width: 800px) {
    flex-direction: row !important;
  }
}
.card-text {
  flex: 1;
  margin-top: 40px;

  @media screen and (min-width: 660px) {
    margin-top: 0 !important;
    margin-left: 1rem;
    margin-right: 1rem;
  }
}
.card-heading {
  font-family: "Roboto", sans-serif;
  font-size: 1.3125rem;
  text-align: center;
  font-weight: 900;
  line-height: 1.37;
  color: #393939;
  // font-size: 1.6875rem;
  @media screen and (min-width: 800px) {
    text-align: left !important;
  }
}
.card-description {
  font-family: "Roboto", sans-serif;
  font-size: 1.0625rem;
  text-align: center;
  line-height: 1.35;
  color: #393939;
  @media screen and (min-width: 800px) {
    text-align: left;
  }
  // font-size: 1.4375rem;
}

.main-title {
  display: none;
  font-family: "Roboto", sans-serif;
  font-size: 2.25rem;
  font-weight: 900;
  line-height: 1.36;
  color: #0a2139;
}
.main-tagline {
  display: none;
  font-family: "Roboto", sans-serif;
  font-size: 1.875rem;
  font-weight: 500;
  line-height: 1.37;
  color: #0a2139;
  margin-bottom: 62px;
}
.logos {
  margin-top: 40px;
  padding-bottom: 40px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  @media screen and (min-width: 800px) {
    position: absolute;
    right: 20px;
    bottom: 0;
  }
}
</style>
